import { render, staticRenderFns } from "./goDraw.vue?vue&type=template&id=2575dffa&"
import script from "./goDraw.vue?vue&type=script&lang=js&"
export * from "./goDraw.vue?vue&type=script&lang=js&"
import style0 from "./goDraw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports